export class i18nError extends Error {
  constructor(
    public i18nKey: string,
    message?: string,
  ) {
    super(message);
  }
}

export class ApiError extends i18nError {
  constructor(
    public statusCode: number,
    public xTraceId: string,
    i18nKey: string,
    message?: string,
    public cause?: Error,
  ) {
    super(i18nKey, message);
  }
}

/**
 * Client error responses
 * Status Code 400番のエラー
 */
export class ApiClient4xxError extends ApiError {}
/**
 * Server error responses
 * Status Code 500番のエラー
 */
export class ApiServer5xxError extends ApiError {}

export class BadRequestError extends ApiClient4xxError {
  constructor(xTraceId: string, message?: string) {
    super(400, xTraceId, "api_error_bad_request", message ?? "400: Bad Request");
  }
}

export class UnauthorizedError extends ApiClient4xxError {
  constructor(xTraceId: string, message?: string) {
    super(401, xTraceId, "api_error_unauthorized", message ?? "401: Unauthorized");
  }
}

export class ForbiddenError extends ApiClient4xxError {
  constructor(xTraceId: string, message?: string) {
    super(403, xTraceId, "api_error_forbidden", message ?? "403: Forbidden");
  }
}

export class NotFoundError extends ApiClient4xxError {
  constructor(xTraceId: string, message?: string) {
    super(404, xTraceId, "api_error_not_found", message ?? "404: NotFound");
  }
}

export class ApiServerError extends ApiServer5xxError {
  constructor(xTraceId: string, message?: string) {
    super(500, xTraceId, "api_error_server", message ?? "500: ApiServerError");
  }
}
export class BadGatewayApiServerError extends ApiServer5xxError {
  constructor(xTraceId: string, message?: string) {
    super(502, xTraceId, "api_error_bad_gateway", message ?? "500: ApiServerError");
  }
}

export class NetworkError extends i18nError {
  constructor(
    public cause: Error,
    message?: string,
  ) {
    super("api_error_network", message);
  }
}

export class ApiPanicError extends i18nError {
  constructor(
    public cause?: unknown,
    public xTraceId?: string,
  ) {
    super("api_error_panic", "予期しないシステムエラー");
  }
}

export type ApiErrorResponse = {
  message?: string;
};
